import Joi from 'joi-browser';
import HttpService from '@pingum/api-services/HttpService';

export default class FeedService {
  static isFeedRequestValid(request) {
    if (request === null || request === undefined) {
      return false;
    }
    const schema = Joi.object().keys({
      name: Joi.string().min(2).max(100).required(),
      type: Joi.string().valid('Hay', 'Grain', 'Supplement', 'Medicine'),
      defaultQuantityMeasure: Joi.string().allow(null, '').valid('lbs', 'oz', 'flakes', 'pills', 'mlcc', 'scoops', 'cups', 'quarts', 'pumps').optional(),
      purchaseInformation: Joi.object().keys({
        vendor: Joi.string().allow(null, ''),
        purchaseLink: Joi.string().allow(null, ''),
        purchaseQty: Joi.string().allow(null, ''),
        purchaseCost: Joi.number().allow(null),
      }),
      color: Joi.string().allow(null, '').optional(),
      order: Joi.number().allow(null, '').optional(),
    });

    return (Joi.validate(request, schema).error === null);
  }

  static getFeeds(page, size, sort, search) {
    return this.httpService.get(`?page=${page}&size=${size}${sort}&search=${search}`);
  }

  static getHorsesForFeed(id) {
    if (!id) {
      return Promise.reject(new Error('Missing Feed ID'));
    }
    return this.httpService.get(`/${id}/horses`);
  }

  static addFeed(request) {
    if (!FeedService.isFeedRequestValid(request)) {
      return Promise.reject(new Error('Invalid add feed request'));
    }

    return new Promise((resolve, reject) => {
      this.httpService.post('/', request).then((response) => {
        resolve(response);
      }, (error) => reject(new Error(error.data.message)));
    });
  }

  static deleteFeed(id, deleteHorseFeeds = false) {
    if (!id) {
      return Promise.reject(new Error('Missing Feed ID'));
    }

    return new Promise((resolve, reject) => {
      this.httpService.delete(`/${id}?deleteHorseFeeds=${deleteHorseFeeds}`).then((response) => {
        resolve(response);
      }, (error) => reject(new Error(error.data.message)));
    });
  }

  static updateFeed(id, request) {
    if (!id) {
      return Promise.reject(new Error('Missing Feed ID'));
    }

    if (!FeedService.isFeedRequestValid(request)) {
      return Promise.reject(new Error('Invalid edit feed request'));
    }

    return new Promise((resolve, reject) => {
      this.httpService.patch(`/${id}`, request).then((response) => {
        resolve(response);
      }, (error) => reject(new Error(error.data.message)));
    });
  }
}

FeedService.httpService = new HttpService({
  baseURL: `${typeof window !== 'undefined'
    ? env.REACT_APP_HORSE_API
    : ''}/feeds`,
});
